import React from 'react'
import Link from 'gatsby-link'

const SectionTry = () => (
  <section className="py-4 py-md-5">
    <div className="container">
      <div className="row">
        <div className="col-sm-9  d-flex pb-2 pb-sm-0 flex-column text-center text-sm-left">
          <h2 className="h2 mb-0">
            Let Evermark find your new customers on Facebook and Instagram.
          </h2>
          <p className="m-0 text-muted">
            <small>Free to get started • Easy setup • Cancel any time</small>
          </p>
        </div>
        <div className="col-sm-3  d-flex align-items-center justify-content-sm-right justify-content-center">
          <Link to="/get-started">
            <button type="button" className="btn btn-primary btn-lg text-white">
              Get Started
            </button>
          </Link>
        </div>
      </div>
    </div>
  </section>
)

export default SectionTry



// WEBPACK FOOTER //
// ./src/components/SectionTry/SectionTry.js